export async function loadConfig(configType, fairId = 0) {
  try {
    let url = 'assets/';
    if (configType === 'base') {
      url += 'configuration/base.json';
    } else if (configType === 'ext') {
      if (!fairId || fairId === 0) throw new Error('No fair id given for extended configuration');

      url += `exhibitions/${fairId}/configuration/configuration.json`;
    } else {
      throw new Error('Unknown configuration type');
    }

    const response = await fetch(url);

    if (!response.ok) throw new Error(`Response status: ${response.status}`);

    return await response.json();
  } catch (e) {
    console.error(`Could not load ${configType} config:`, e);
  }
}
